<template>
  <div id="sticker-wrapper" class="card">
    <div class="icon-button-wrapper" v-if="card">
      <svg
        class="icon-button"
        id="emoji-button"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        @click="($event) => picker.togglePicker($event)"
      >
        <path
          d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
      <label for="" class="icon-button-sticker"> Add Sticker </label>
    </div>

    <div class="icon-button-wrapper">
      <svg
        class="icon-button"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25V18A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
      <label for="" class="icon-button-sticker"> Add Child Card </label>
    </div>

    <router-link class="icon-button-wrapper" :to="splitLink">
      <!-- trigger 'split' route -->
      <svg
        class="icon-button"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
      <label for="" class="icon-button-sticker"> Split Card </label>
    </router-link>

    <div class="icon-button-wrapper" @click="jumpToCard">
      <svg
        class="icon-button"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
      <label for="" class="icon-button-sticker"> Edit Card </label>
    </div>
  </div>
  <div class="wrapper">
    <transition name="fade" mode="out-in" id="card-wrapper" v-if="card">
      <div class="" :key="card.id">
        <div id="main-row">
          <div class="card queue-card" id="inner-queue-card" :class="card.type">
            <div class="top-row" id="top-row">
              {{ card.pack_name }}
            </div>

            <div
              v-for="sticker in card.stickers"
              :key="sticker.id"
              class="sticker"
              :style="{
                top: sticker.y + 'px',
                left: sticker.x + 'px',
              }"
            >
              {{ sticker.sticker }}
            </div>

            <div
              id="active-sticker"
              v-if="activeSticker"
              :style="{
                top: activeSticker.y + 'px',
                left: activeSticker.x + 'px',
              }"
            >
              {{ activeSticker.sticker }}
            </div>

            <div id="front">
              <Markdown
                v-if="card.type === 'project'"
                :source="'## This is your project for today: \n' + front"
                :class="{
                  'normal-text': card.front.length > 100,
                  'align-left': card.front.length > 100,
                }"
              />

              <Markdown
                v-else-if="card.type === 'readingList'"
                :source="'## Read at least a page of: \n' + front"
                :class="{
                  'normal-text': card.front.length > 100,
                  'align-left': card.front.length > 100,
                }"
              />

              <Markdown
                v-else-if="card.type === 'articleList'"
                :source="'## Read this and make notes: \n' + front"
                :class="{
                  'normal-text': card.front.length > 100,
                  'align-left': card.front.length > 100,
                }"
              />
              <Markdown
                v-else
                :source="front"
                :class="{
                  'normal-text': card.front.length > 100,
                  'align-left': card.front.length > 100,
                }"
              />
            </div>
            <div
              id="queue-spacer"
              v-if="showBack || (card.occurrences == 0 && card.type == 'learn')"
            ></div>
            <Markdown
              v-if="showBack || (card.occurrences == 0 && card.type == 'learn')"
              :source="back"
              :class="{
                'normal-text': card.back.length > 100,
                'align-left': card.back.length > 100,
              }"
              id="back"
            />
          </div>
        </div>
        <div id="queue-buttons">
          <div v-if="card.type == 'learn'">
            <div v-if="showBack" class="button-list">
              <button
                :disabled="!buttonsEnabled"
                class="button queue-button button-1 hide-on-mobile"
                @click="nextCard(1, 1)"
              >
                Blackout
              </button>
              <button
                :disabled="!buttonsEnabled"
                class="button queue-button button-2"
                @click="nextCard(2, 1)"
              >
                Wrong
              </button>
              <button
                :disabled="!buttonsEnabled"
                class="button queue-button button-3 hide-on-mobile"
                @click="nextCard(3, 1)"
              >
                Correct-ish
              </button>
              <button
                :disabled="!buttonsEnabled"
                class="button queue-button button-4"
                @click="nextCard(4, 1)"
              >
                Good
              </button>
              <button
                :disabled="!buttonsEnabled"
                class="button queue-button button-5"
                @click="nextCard(5, 1)"
              >
                Easy
              </button>
            </div>
            <div v-else class="button-list">
              <button
                @click="setShowBack(true)"
                v-if="card.occurrences > 0"
                :disabled="!buttonsEnabled"
                class="button queue-button button-1"
              >
                Reveal!
              </button>
              <div v-else id="first-time-wrapper">
                <div class="normal-text">
                  Whenever you see a learn card for the first time, it shows you
                  both question and answer. Later on, you will be prompted to
                  remember the answer first.
                </div>
                <button
                  :disabled="!buttonsEnabled"
                  class="button queue-button button-1"
                  @click="nextCard(0, 1)"
                >
                  Thanks, I will remember.
                </button>
              </div>
            </div>
          </div>
          <div v-if="card.type == 'habit'" class="button-list">
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-1"
              @click="addNote(1, -1)"
            >
              Not Today
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-2"
              @click="nextCard(2, 0)"
            >
              Will Do Later
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-4"
              @click="nextCard(5, 20)"
            >
              Done
            </button>
          </div>
          <div v-if="card.type === 'todo'" class="button-list">
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-1 hide-on-mobile"
              @click="nextCard(1, 1)"
            >
              Delete
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-2"
              @click="addNote(2, -1)"
            >
              Not Today
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-3"
              @click="nextCard(3, 0)"
            >
              Will Do Later
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-4"
              @click="nextCard(4, 10)"
            >
              Check
            </button>
          </div>

          <div v-if="card.type === 'articleList'" class="button-list">
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-1 hide-on-mobile"
              @click="nextCard(1, 1)"
            >
              Delete
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-2"
              @click="addNote(2, -1)"
            >
              Not Today
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-3"
              @click="nextCard(3, 0)"
            >
              Will Do Later
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-3 hide-on-mobile"
              @click="nextCard(4, 1)"
            >
              Made Some Progress
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-4"
              @click="nextCard(5, 30)"
            >
              Done
            </button>
          </div>

          <div v-if="card.type === 'readingList'" class="button-list">
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-1 hide-on-mobile"
              @click="nextCard(1, 1)"
            >
              Delete
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-2 hide-on-mobile"
              @click="addNote(2, -1)"
            >
              Not Today
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-3"
              @click="nextCard(3, 0)"
            >
              Will Do Later
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-4"
              @click="nextCard(4, 10)"
            >
              Check
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button"
              @click="nextCard(5, 10)"
            >
              Finished
            </button>
          </div>
          <div v-if="card.type == 'check'" class="button-list">
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-1"
              @click="nextCard(1, -0)"
            >
              No
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-2"
              @click="nextCard(3, 2)"
            >
              Kinda
            </button>
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-4"
              @click="nextCard(5, 5)"
            >
              Yes
            </button>
          </div>
          <div v-if="card.type === 'standard'" class="button-list">
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-5"
              @click="nextCard(1, 1)"
            >
              Cool, thx
            </button>
          </div>
          <div v-if="card.type === 'media'" class="button-list">
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-5"
              @click="nextCard(99, 99)"
            >
              Next
            </button>
          </div>
          <div v-if="card.type === 'project'" class="button-list">
            <button
              :disabled="!buttonsEnabled"
              class="button queue-button button-5"
              @click="nextCard(1, 1)"
            >
              Alright, got it scheduled
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in" v-else class="center" id="queue-done">
      <div>
        <span> ... </span>
        <span class="delay">
          This is taking a long time. You may be out of due cards.
        </span>
      </div>
    </transition>

    <div class="overlay-card card queue-card" v-if="overlay">
      <p>
        You are about to skip <em>{{ card.front.slice(0, 20) }}</em
        >... for the day.
      </p>
      <p>
        Please provide a reason why you do not want to do this card right now:
      </p>
      <textarea
        class="card-content"
        v-model="skipNote"
        placeholder="Please write a sentence about your reasoning."
      ></textarea>
      <div v-if="skipNote">
        <button @click="overlay = false" class="button">Cancel</button>
        <button
          @click="nextCard(this.savedVote, this.savedScore)"
          class="button button-primary"
        >
          Skip Card
        </button>
      </div>
    </div>
    <svg
      @click="overlay = false"
      v-if="overlay"
      id="deactivatePreview"
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <div class="overlay" v-if="overlay"></div>
  </div>
</template>
<script>
import Markdown from "vue3-markdown-it";
import { supabase } from "../supabase";
import { useEventListener } from "@vueuse/core";
import { EmojiButton } from "@joeattardi/emoji-button";
import { v4 as uuidv4 } from "uuid";

export default {
  data() {
    return {
      searchTerm: "",
      buttonsEnabled: true,
      front: "...loading",
      back: "...loading",
      queueLoading: true,
      currentCard: null,
      followingCard: null,
      overlay: false,
      savedVote: null,
      savedScore: null,
      skipNote: "",
      showCelebration: true,
      stickerIsMoving: false,
      picker: new EmojiButton(),
      activeSticker: null,
      stopStickerListenerActive: false,
    };
  },
  components: {
    Markdown,
  },
  methods: {
    startButtonCounter: function () {
      this.buttonsEnabled = false;
      // activate buttons after three seconds
      setTimeout(() => {
        this.buttonsEnabled = true;
      }, 3000);
    },
    nextCard: function (vote, score) {
      // let card flash if easy/correct
      if (vote > 3) {
        // find element inner-queue-card
        let card = document.getElementById("inner-queue-card");
        card.classList.remove("card-correct");
        card.classList.add("card-correct");
      }
      if (vote !== 99) {
        this.$store.dispatch("setNextShownOfCard", {
          vote,
          score,
          skipNote: this.skipNote,
        });
      }
      this.overlay = false;
      this.skipNote = "";

      if (this.$store.state.followingQueueCard == null) {
        this.front = "...loading";
        this.back = "...loading";
        this.$store.commit("setCurrentQueueCard", null);
        this.generateQueue();
      } else {
        this.$store.commit(
          "setCurrentQueueCard",
          this.$store.state.followingQueueCard
        );
      }

      let cardToPick = {
        which: "following",
        type: Math.floor(Math.random() * 4) + 1,
      };

      this.$store.dispatch("pickCard", cardToPick);
      this.replaceImages();
    },
    setShowBack: function (showBack) {
      this.$store.commit("setShowBack", showBack);
    },
    jumpToCard: function () {
      this.$store.dispatch("setCurrentEditCardId", this.card.id).then(() => {
        this.$store.dispatch("setCurrentPackId", this.card.pack_id).then(() => {
          this.$router.push("/collection");
        });
      });
    },
    generateQueue: function () {
      if (this.card) {
        this.replaceImages();
      } else {
        let cardToPick = {
          which: "current",
          type: Math.floor(Math.random() * 4) + 1,
        };
        this.$store.dispatch("pickCard", cardToPick).then(() => {
          cardToPick = {
            which: "following",
            type: Math.floor(Math.random() * 4) + 1,
          };
          this.$store.dispatch("pickCard", cardToPick).then(() => {
            this.replaceImages();
          });
        });
      }
    },
    async replaceImages() {
      if (this.card !== null && this.card !== undefined) {
        this.front = this.card.front || "";
        this.back = this.card.back || "";
        const regex = /{{ ([^}]*) }}/gm;
        let matches = this.card.front.match(regex);
        if (matches !== null) {
          for (const match of matches) {
            const imgName = match.replace("{{ ", "").replace(" }}", "");
            try {
              const { data, error } = supabase.storage
                .from("user-images")
                .getPublicUrl(`${supabase.auth.currentUser.id}/${imgName}`);
              if (error) throw error;

              this.front = this.front.replace(
                match,
                `![${imgName}](${data.publicURL})`
              );
            } catch (error) {
              console.warn(error);
            }
          }
        }
        matches = this.card.back.match(regex);
        if (matches !== null) {
          for (const match of matches) {
            const imgName = match.replace("{{ ", "").replace(" }}", "");
            try {
              const { data, error } = supabase.storage
                .from("user-images")
                .getPublicUrl(`${supabase.auth.currentUser.id}/${imgName}`);
              if (error) throw error;

              this.back = this.back.replace(
                match,
                `![${imgName}](${data.publicURL})`
              );
            } catch (error) {
              console.warn(error);
            }
          }
        }
      }
    },
    addNote: function (vote, score) {
      this.overlay = true;
      this.savedVote = vote;
      this.savedScore = score;
    },
    // STICKER METHODS
    moveSticker: function (e) {
      if (this.activeSticker) {
        this.activeSticker.x = e.pageX;
        this.activeSticker.y = e.pageY;
      }
    },
    stopMovingSticker: async function () {
      if (this.activeSticker && this.stopStickerListenerActive) {
        this.stopStickerListenerActive = false;
        // save sticker to backend
        try {
          const { data, error } = await supabase.from("stickers").insert([
            {
              cardId: this.card.id,
              x: parseInt(this.activeSticker.x),
              y: parseInt(this.activeSticker.y),
              sticker: this.activeSticker.sticker,
            },
          ]);
          if (error) throw error;
          console.log("sticker saved!", data);
        } catch (error) {
          console.warn(error);
        }

        console.log("sticker stopped moving");
        this.card.stickers.push(this.activeSticker);
        this.activeSticker = null;
      }
    },
  },
  created: function () {
    this.$store.dispatch("getCollections");
    this.generateQueue();
    // Emoji/Sticker handling
    this.picker.on("emoji", (selection) => {
      // create a div with the emoji as content
      // sticker.class = "sticker";
      this.activeSticker = {
        x: 0,
        y: 0,
        sticker: selection.emoji,
      };

      // add click listener after .2 sec
      setTimeout(() => {
        useEventListener("click", this.stopMovingSticker);
        this.stopStickerListenerActive = true;
      }, 200);
      // add mousemove listener
      useEventListener("mousemove", this.moveSticker);
    });
  },
  mounted: async function () {},
  computed: {
    card: function () {
      let card = this.$store.state.currentQueueCard;
      // if card is not null or empty
      if (card !== null && card !== undefined) {
        // replace title of page with card.front
        document.title = card.front.substring(0, 38);
        if (card.front.length > 38) {
          document.title += "...";
        }

        // get stickers from backend and place
        card.stickers = [];
        try {
          supabase
            .from("stickers")
            .select("*")
            .eq("cardId", card.id)
            .then(({ data, error }) => {
              if (error) throw error;
              console.log("stickers", data);
              for (const sticker of data) {
                card.stickers.push(sticker);
              }
            });
        } catch (error) {
          console.warn(error);
        }
      }

      return card;
    },
    showBack: function () {
      return this.$store.state.showBack;
    },
    splitLink: function() {
      if (this.card) {
        return `/split/' + ${this.card.id}`
      }
      else {
        return ''
      }
    }
  },
};
</script>
